export default "__VITE_ASSET__DASQpOef__"